import { Skeleton } from '@morpho-org/ui-v6/server'
import { cn } from '@morpho-org/ui-v6/utils'
import { forwardRef, memo } from 'react'

interface SelectTokenTextInputProps {
  onFocus(): void
  onBlur(): void
  onChange(event: React.ChangeEvent<HTMLInputElement>): void
  value: string
  autoFocus?: boolean
  disabled?: boolean
  isLoading?: boolean
  hasError?: boolean
  testId?: string
}

const SelectTokenTextInput = forwardRef<HTMLInputElement, SelectTokenTextInputProps>(
  ({ onFocus, onBlur, value, autoFocus, disabled, onChange, isLoading, hasError, testId }, ref) => {
    if (isLoading) {
      return <Skeleton className="h-[33px] w-[124px]" />
    }

    return (
      <input
        aria-label="Asset Input"
        ref={ref}
        placeholder="0"
        value={value}
        autoFocus={autoFocus}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        inputMode="decimal"
        lang="en-US"
        data-testid={testId}
        className={cn(
          'text-xl h-[33px] w-full border-none bg-transparent p-0 outline-none',
          'truncate',
          'placeholder:text-muted-foreground disabled:cursor-not-allowed',
          hasError
            ? 'text-destructive-foreground caret-destructive-foreground'
            : 'text-foreground caret-primary'
        )}
      />
    )
  }
)

SelectTokenTextInput.displayName = 'SelectTokenTextInput'

export default memo(SelectTokenTextInput)
